var React = require('react');

function Print (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group"},React.createElement("path",{"id":"Vector","d":"M16.5 10.5H18.75M5.25 18.75H1.5V6.75H22.5V18.75H18.75H5.25ZM5.25 14.25V22.5H18.75V14.25H5.25ZM18.75 6.75V1.5H5.25V6.75H18.75Z","stroke":"#0088BF","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"})));
}

Print.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Print;

Print.default = Print;
